export function getShowcaseVariant(value = "") {
  const text = value.toLowerCase();

  if (text.includes("poster") || text.includes("social")) {
    return "posters";
  }

  if (text.includes("reel") || text.includes("brand") || text.includes("identity")) {
    return "identity";
  }

  if (
    text.includes("ad") ||
    text.includes("profile") ||
    text.includes("campaign") ||
    text.includes("google business")
  ) {
    return "ads";
  }

  if (text.includes("monthly")) {
    return "monthly";
  }

  if (
    text.includes("industry") ||
    text.includes("clinic") ||
    text.includes("startup") ||
    text.includes("restaurant") ||
    text.includes("salon") ||
    text.includes("construction") ||
    text.includes("retail") ||
    text.includes("education")
  ) {
    return "industry";
  }

  return "posters";
}
